import { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { closeModal } from 'store/actions/modals'
import { getMenuItems, ScheduleMenuItem } from 'Manager/Schedule/SchedulerContextMenu/helpers'
import { useMultiItemsMobile, useSingleItemsMobile } from 'Manager/Schedule/SchedulerContextMenu/hooks'
import { isMobile } from 'services/Utilities'
import BaseModalActions from 'components/Modals/BaseModalActions'
import { Button } from 'components/Forms'
import { Address } from 'components/UI'
import { List } from 'ui'

type Props = {
  events: MData.SchedulerEvent[]
}

const ScheduleMobileActionsModal: FC<Props> = ({ events }) => {
  const event = events[0]
  const dispatch = useDispatch()

  const { forceCancelledShifts, editFinalizedShifts } = useSelector((state: MStore.RootState) => state.settings)
  const { tagsById, scheduleTemplatesById } = useSelector((state: MStore.RootState) => state.resources)

  const { tags = [] } = event
  const locations: string[] = tags.filter(tag => tagsById[tag].type === 'locations')

  const multiItemsMobile = useMultiItemsMobile(events)
  const singleItemsMobile = useSingleItemsMobile(event)
  const isMultiSelection = events.length > 1

  const items = isMultiSelection ? multiItemsMobile : singleItemsMobile
  const selectedEvents = isMultiSelection ? events : [event]

  const eventItems = getMenuItems(selectedEvents, items, {
    isMultiSelection,
    isMobile: !!isMobile(),
    scheduleTemplatesById,
    forceCancelledShifts,
    editFinalizedShifts
  }) as (ScheduleMenuItem & { onClick: () => void })[]

  return (
    <BaseModalActions>
      {/* Section to show shift locations at the top of the modal */}
      {locations.length ? (
        <List className="mb-2">
          <List.Item>
            {locations.map(location => {
              const { icon, name, address } = tagsById[location]
              return (
                <div key={location} className="d-xl-none">
                  <i className={`fa ${icon} mr-1`} />
                  <b>{name}</b>
                  <div>
                    <u>
                      <Address address={address} minimum withLink icon className="font-italic" />
                    </u>
                  </div>
                </div>
              )
            })}
          </List.Item>
        </List>
      ) : null}
      <List className="mb-2">
        {eventItems.map(({ text, onClick }, index) => (
          <Button
            key={index}
            onClick={() => {
              dispatch(closeModal())
              onClick()
            }}
            className="list-group-item list-group-item-action list-group-flush"
          >
            {text}
          </Button>
        ))}
      </List>
    </BaseModalActions>
  )
}

export default ScheduleMobileActionsModal
